import { useState } from 'react';
import mobxInjectSelect from '../../../utils/mobxInjectSelect';
import { Card } from '../../WebComponents';
import { Slider } from '../../../../admin/shared-components/Slider/Slider';
import { BANG_FILTER_OPTIONS } from '../../../../stores/SessionStore';
import styles from './BangFilterSettings.module.css';

type MobxProps = {
  setBangFilterSetting: (bangFilterSetting: number) => void;
  bangFilterSetting: number;
};

type BangFilterSettingsProps = {};

const BangFilterSettings = ({
  setBangFilterSetting,
  bangFilterSetting,
}: BangFilterSettingsProps & MobxProps) => {
  const initIndex = BANG_FILTER_OPTIONS.findIndex((option) => option.value === bangFilterSetting);
  const [bangFilterIndex, setBangFilterIndex] = useState<number>(
    initIndex !== -1 ? initIndex : BANG_FILTER_OPTIONS.length - 1
  );

  const handleBangFilterChange = (value: number, index: number) => {
    setBangFilterIndex(index);
    setBangFilterSetting(value);
  };

  return (
    <div className={styles.holder} tabIndex={-1}>
      <Card header="BANG FILTER SETTINGS">
        <div className={styles.sliderContainer}>
          <Slider
            labelClassName={styles.sliderLabel}
            disabled={false}
            dataTestId="bang-filter-slider"
            initialIndex={bangFilterIndex}
            initialLabel={BANG_FILTER_OPTIONS[bangFilterIndex]?.label}
            options={BANG_FILTER_OPTIONS}
            onChange={handleBangFilterChange}
          />
        </div>
        <div className={styles.description}>
          {`Any bang event received that is older than ${BANG_FILTER_OPTIONS[bangFilterIndex]?.label} ago will be ignored. After updating this setting, please refresh the page to apply the changes.`}
        </div>
      </Card>
    </div>
  );
};

export default mobxInjectSelect<BangFilterSettingsProps, MobxProps>({
  sessionStore: ['setBangFilterSetting', 'bangFilterSetting'],
})(BangFilterSettings);
